import "./quotation.scss";

import { Outlet } from "react-router-dom";

import { FilterQuotationProvider } from "./filter-quotation/filter-quotation.context";

export function Quotation() {
  return (
    <div id="ShellQuotation" className="quotation">
      <FilterQuotationProvider>
        <Outlet />
      </FilterQuotationProvider>
    </div>
  );
}

export default Quotation;
